<template>
  <layout-card-wrap style="margin-top:15px"
                    hasHeaderSlot
                    v-loading="loading">
    <div slot="title">检验商品
      <el-button type="primary"
                 v-if="editable"
                 style="margin: 0 10px"
                 @click="associate">添加</el-button>
      <el-dropdown v-if="editable">
        <el-button type="primary">
          更多菜单<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="downloadTemp">下载检验商品excel模板</el-dropdown-item>
          <el-dropdown-item @click.native="uploadTemp">批量上传检验商品</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <el-form ref="ruleForm"
             :validate-on-rule-change="false"
             :rules="rules"
             :model="inspect">
      <el-form-item label-width="0"
                    prop="inspectReportDetails">
        <el-table border
                  max-height="1000px"
                  show-summary
                  :summary-method="getSummaries"
                  :data="inspect.inspectReportDetails">
          <el-table-column type="index"
                           width="50">
          </el-table-column>
          <el-table-column label="首次"
                           v-if="!editable"
                           width="60">
            <template slot-scope="{row}">
              <el-tag v-if="row.firstInspect === 1"
                      type="danger"
                      style="height: 16px;line-height: 14px"
                      effect="dark"
                      size="mini">首次</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="商品名称"
                           min-width="200"
                           prop="productName">
          </el-table-column>
          <!-- <el-table-column label="监管类别"
                           width="100">
            <template slot-scope="{row}">
              <el-tag v-if="row.legalTest === 0">非法检</el-tag>
              <el-tag type="danger"
                      v-if="row.legalTest === 1">法检</el-tag>
            </template>
          </el-table-column> -->
          <el-table-column label="商品数量"
                           min-width="160"
                           v-if="editable">
            <template slot-scope="{row,$index}">
              <el-form-item label-width='0'
                            :prop="'inspectReportDetails.' + $index + '.productCount'"
                            :rules="[{required: true, message: '请输入商品数量', trigger: 'blur'}]">
                <el-input-number v-model="inspect.inspectReportDetails[$index].productCount"
                                 :precision="0"
                                 :controls="false"
                                 :min="1"></el-input-number>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="商品数量"
                           min-width="160"
                           v-else
                           prop="productCount">
          </el-table-column>
          <!-- <el-table-column label="创建时间"
                           width="100">
            <template slot-scope="{row}">
              {{ row.createdTime | dateformat('YYYY-MM-DD')}}
            </template>
          </el-table-column> -->
          <el-table-column label="批次数量"
                           width="100">
            <template slot-scope="{row}">
              {{row.batchs ? row.batchs.length : 0}}
            </template>
          </el-table-column>
          <el-table-column label="批次商品数量"
                           width="100">
            <template slot-scope="{row}">
              {{row.batchsGoodsCount || 0}}
            </template>
          </el-table-column>
          <el-table-column label="批次信息"
                           width="170">
            <template slot-scope="{$index, row}">
              <el-button :type="(editable || inspect.status === 3) && userPermission.ENT ? 'primary' : 'text'"
                         @click="viewBatch($index,row)">{{(editable || inspect.status === 3) && userPermission.ENT ? '关联批次' : '查看'}}</el-button>
              <el-button :type="'danger'"
                         v-if="(editable) && userPermission.ENT"
                         @click="deleteItem($index,row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
    </el-form>
    <associate-product-modal ref="modal"
                             :selected="inspect.inspectReportDetails"
                             @update:selection="handleSelectionChange"
                             :isSubOrder="isSubOrder"
                             :option="option" />

    <associate-product-batch-modal :tradeType="tradeType"
                                   :vendorId="vendorId"
                                   :status="inspect.status"
                                   @update:selection="handleBatchChange"
                                   ref="batchModal" />
    <xls-decode-to-data ref="xls" />
    <upload-new action="inspect/batchupdateinspectproduct"
                accept=".xls,.xlsx"
                ref="uploadNew"
                v-model="loading"
                :callback="batchproductcallback" />
  </layout-card-wrap>
</template>

<script>
import AssociateProductModal from './associate-product-modal.vue'
import AssociateProductBatchModal from './associate-product-batch-modal.vue'

// import clonedeep from 'lodash.clonedeep'
import { mapState } from 'vuex'
import XlsDecodeToData from '../../../components/xls-decode-to-data.vue'
import UploadNew from '../../../components/upload-new.vue'

export default {
  name: 'associate-product',
  components: { AssociateProductModal, AssociateProductBatchModal, XlsDecodeToData, UploadNew },
  props: {
    loading: [Boolean],
    editable: {
      type: Boolean,
      default: true
    },
    tradeType: [Number, String],
    vendorId: [Number, String],
    value: {
      required: true
    },
    isSubOrder: { type: Boolean, default: false },
    options: { type: Object, default () { return { parentInspectReportId: null, subInspectReportId: null } } }
  },
  data () {
    return {
      rules: {
        inspectReportDetails: [
          { type: 'array', required: true, message: '请选择商品', trigger: 'change' }
        ]
      }
    }
  },
  computed: {
    option ({ tradeType, vendorId, options }) {
      return { tradeType, vendorId, ...options }
    },
    ...mapState({
      userPermission: state => state.account.permission
    }),
    inspect: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    downloadTemp () {
      this.$store.dispatch('inspect/downloadinspectproducttemplate', {
        payload: { },
        success: (res) => { },
        fail: () => { }
      })
    },
    uploadTemp () {
      this.$refs.uploadNew.upload({
        // vendorId: row.vendorId
      })
    },
    batchproductcallback (options, url, data) {
      console.log(data)
      let records = data.records || []
      const inspectReportDetails = this.inspect.inspectReportDetails
      let listNew = [...inspectReportDetails, ...records]
      const productMap = {}
      let listResult = []
      listNew.forEach((item, index) => {
        const productId = item.productId
        const indexNew = productMap[productId]
        if (indexNew > -1) {
          listResult[indexNew].productCount = item.productCount
        } else {
          productMap[productId] = index
          listResult.push(item)
        }
      })
      this.$set(this.inspect, 'inspectReportDetails', listResult)
    },
    getSummaries () {
      const inspectReportDetails = this.inspect.inspectReportDetails
      let count = 0
      let batchcount = 0
      let batchproductcount = 0
      inspectReportDetails.forEach(i => {
        count += (i.productCount || 0)
        batchcount += (i.batchs ? i.batchs.length : 0)
        batchproductcount += (i.batchsGoodsCount || 0)
      })
      return !this.editable ? [inspectReportDetails.length, '合计：', '-', count, batchcount, batchproductcount, '-'] : [inspectReportDetails.length, '合计：', count, batchcount, batchproductcount, '-']
    },
    uploadXls () {
      this.$refs.xls.upload()
    },
    associate () {
      // this.$refs.modal.toggleModal(true)
      this.$refs.modal.fetch()
    },
    viewBatch (index, row) {
      this.$refs.batchModal.fetch(index, row, this.inspect)
    },
    deleteItem ($index, row) {
      this.inspect.inspectReportDetails.splice($index, 1)
    },
    handleSelectionChange (rows) {
      // let inspectReportDetails = clonedeep(this.inspect.inspectReportDetails)
      // rows.forEach(i => {
      //   if (inspectReportDetails.findIndex(s => s.productId === i.productId) === -1) {
      //     i.batchs = []
      //     inspectReportDetails.push(i)
      //   }
      // })
      let list = rows.map(i => {
        let item = this.inspect.inspectReportDetails.find(s => s.productId === i.productId) || {}
        // i.productCount = item.productCount || 1
        i = {
          ...i,
          ...item
        }
        return i
      })
      this.$set(this.inspect, 'inspectReportDetails', list)
      // this.inspect.inspectReportDetails = list
    },
    handleBatchChange (index, list) {
      const item = this.inspect.inspectReportDetails[index]
      const batchsGoodsCount = list.map(i => i.goodsCount).reduce((t, c) => t + c, 0)
      if (batchsGoodsCount > item.productCount) {
        this.$message.error(`批次商品数量(${batchsGoodsCount}件)不能大于报检商品数量(${item.productCount}件)`)
        return
      }
      item.batchs = list
      item.batchsGoodsCount = batchsGoodsCount
      this.$set(this.inspect.inspectReportDetails, index, item)
      this.$refs.batchModal.toggleModal(false)
    },
    submit (cb) {
      return new Promise((resolve, reject) => {
        this.$refs.ruleForm.validate(valid => {
          if (valid) {
            resolve(this.inspect.inspectReportDetails.map(i => ({ productId: i.productId, productCount: i.productCount })))
          } else {
            reject(new Error('商品必须选择'))
          }
        })
      })
      // this.$refs.ruleForm.validate(valid => {
      //   if (valid) {
      //     cb && cb(this.data.list.map(i => ({ productId: i.productId, productCount: i.productCount })))
      //   }
      // })
    }
  }
}
</script>
